import { SerializedAdConfig } from 'types/AdConfig';
import { Targeting, Dimension } from './GoogleAds';
import ScreenSize from './ScreenSize';

interface Config {
  targeting: Targeting;
  screenSizes?: ScreenSize[] | undefined;
  elementId: string;
  dimensions: Dimension[];
}

export default class AdConfig {
  config: Config;

  constructor(config: Config) {
    this.config = config;
  }

  toJSON(): SerializedAdConfig {
    return {
      targeting: this.config.targeting,
      screenSizes: this.config.screenSizes
        ? this.config.screenSizes.map((ss) => ss.toJSON())
        : undefined,
      elementId: this.config.elementId,
      dimensions: this.config.dimensions,
    };
  }
}
